import {RouterModule, Routes} from '@angular/router';

import {LayoutComponent} from './layout.component';

import {ResourceComponent} from '../resource/resource.component';
import {FilterbuilderComponent} from '../shared/filterbuilder/filterbuilder.component';
import {CanDeactivateGuard} from '../resource/detail/controls/canDeactivateGuard/canDeactivateGuard';
import {HomeComponent} from '../resource/home/home.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {path: '', redirectTo: '/home/home', pathMatch: 'full'},

      {path: 'dashboard', redirectTo: '/admin/dashboard', pathMatch: 'full'},
      {path: 'requests', redirectTo: '/admin/requests', pathMatch: 'full'},
      {path: 'administration', redirectTo: '/admin/administration', pathMatch: 'full'},
      {path: 'allresources', redirectTo: '/admin/allresources', pathMatch: 'full'},
      {
        path: 'admin',
        loadChildren: () =>
          import('../static-pages/static-pages.module').then(m => m.StaticPagesModule),
      },
      {path: 'filterbuilder', component: FilterbuilderComponent},
      {path: 'home', redirectTo: '/home/home', pathMatch: 'full'},
      {path: 'home/:id', component: HomeComponent},
      {
        path: ':sitetype/:id',
        component: ResourceComponent,
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':sitetype/:id/:id2',
        component: ResourceComponent,
        canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
];

export const LayoutRoutingModule = RouterModule.forChild(routes);
